import CoreScroll from '../../mixins/core-scroll'
import CoreResize from '../../mixins/core-resize'
import AppFixed from '../../mixins/app-fixed'


export default
{
    name: 'app-modal',

    mixins:
    [
        CoreScroll,
        CoreResize,
        AppFixed
    ],

    props:
    {
        transform: { type: String, default: '' }
    },

    mounted()
    {
        this.onResized(0, this.resize.height)
    },

    methods:
    {
        onResized(w, h)
        {
            this._updateTransform()
        },

        onScroll(y)
        {
            this._updateTransform()
        },

        _updateTransform()
        {
            if (this.$root.isFakeScroll)
            {
                const y = this.scroll.smoothY.toFixed(0)
                const rule = this.transform + ' translateY(' + y + 'px) translateZ(0)'
                this.$el.style.transform = rule
            }
        }
    }
}


// WEBPACK FOOTER //
// ./src/scripts/components/app-modal/script.js